import { AnnounceCard } from "components/report/ChatArea/AnnounceCard";
import { ChatCard } from "components/report/ChatArea/ChatCard";
import { DateBot } from "components/report/ChatArea/DateBot";
import { monitorColors } from "components/report/ChatArea/chatColors";
import {
  getMonitorColor,
  getMonitorName,
  useChatDataList,
} from "components/report/ChatArea/hooks";
import {
  StyledDisplayAreaDiv,
  StyledMain,
} from "components/report/ChatArea/styled";
import React from "react";
import { ChatDataType } from "types/graphqlapi";
import { gethhmmStr } from "utils/common";

type ChatAreaProps = {
  subjectId: string;
  interviewId: string;
};

export const ChatArea: React.FC<ChatAreaProps> = (props: ChatAreaProps) => {
  const { chatDataList, monitorList } = useChatDataList(
    props.interviewId,
    props.subjectId
  );

  if (chatDataList.length === 0) return <></>;

  const displayChatDataList = chatDataList.map((chat) => {
    return {
      ...chat,
      ...(chat.mentioned_monitor_id_list && {
        mentionedMonitorList: chat.mentioned_monitor_id_list
          .split(",")
          .map((id) => {
            return { id, name: getMonitorName(monitorList, id) };
          }),
      }),
    };
  });

  return (
    <StyledMain>
      <StyledDisplayAreaDiv>
        {displayChatDataList.map((chat, index) => {
          if (!chat.type) return <AnnounceCard text={chat.text} />;
          //InterviewerAnnounceはtypeを持たない
          else if (
            chat.type === ChatDataType.SYSTEMLOG &&
            chat.text === "Date"
          ) {
            return <DateBot key={index} createdAt={chat.createdAt || ""} />;
          } else if (chat.monitor_id) {
            return (
              <ChatCard
                key={index}
                name={getMonitorName(monitorList, chat.monitor_id)}
                chat={chat}
                createdAt={
                  chat.createdAt
                    ? gethhmmStr(new Date(chat.createdAt))
                    : undefined
                }
                color={getMonitorColor(monitorList, chat.monitor_id)}
              />
            );
          } else {
            return (
              <ChatCard
                key={index}
                name={"インタビュアー"}
                chat={chat}
                createdAt={
                  chat.createdAt
                    ? gethhmmStr(new Date(chat.createdAt))
                    : undefined
                }
                color={monitorColors.green}
                reverse
                isMyChat
              />
            );
          }
        })}
      </StyledDisplayAreaDiv>
    </StyledMain>
  );
};
